import { render, staticRenderFns } from "./ChildrenScholarship.vue?vue&type=template&id=68291298&scoped=true&"
import script from "./ChildrenScholarship.vue?vue&type=script&lang=js&"
export * from "./ChildrenScholarship.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenScholarship.vue?vue&type=style&index=0&id=68291298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68291298",
  null
  
)

export default component.exports